import { cn } from '~/style';

export const Form = ({
  title,
  onSubmit,
  children,
  className,
}: {
  title?: string;
  onSubmit?: () => void;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <form
      className={cn(
        'mx-auto w-full max-w-2xl space-y-6 md:space-y-10 lg:space-y-14',
        className,
      )}
      onSubmit={(event) => {
        event.preventDefault();

        onSubmit?.();
      }}
    >
      {title && (
        <div className="text-xl font-semibold md:text-2xl lg:text-3xl">
          {title}
        </div>
      )}

      {children}
    </form>
  );
};
